import React, { useState } from 'react'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'
import { CodeScannerDrawer } from './CodeScannerDrawer.component'
import { useTranslation } from 'react-i18next'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { B2COrderResponseFragment } from 'parkdepot-shared/gql/graphql'
import { Qr } from '@assets/index'

const isQRScanningSupported = () => {
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

    if (!hasTouch || !isMobileUA) return false

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
    if (!isIOS) return true // Not iOS, should be supported

    const match = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/)
    if (!match) return false

    const majorVersion = parseInt(match[1], 10)
    const minorVersion = parseInt(match[2], 10)

    return majorVersion > 15 || (majorVersion === 15 && minorVersion >= 1)
}

const CodeScanner = ({ orderData, disabled }: { orderData: B2COrderResponseFragment; disabled: boolean }) => {
    const { t } = useTranslation()

    const [scannerModalOpen, setScannerModalOpen] = useState(false)

    if (!isQRScanningSupported() || disabled) {
        return null
    }

    return (
        <>
            <CodeScannerDrawer
                isOpen={scannerModalOpen}
                onClose={() => setScannerModalOpen(false)}
                orderData={orderData}
            />
            <Button
                id="apply-code-button"
                data-testid="applyCodeButton"
                onClick={() => setScannerModalOpen(true)}
                $kind={BUTTON_KIND.secondary}
                $size={BUTTON_SIZE.medium}
                overrides={{
                    BaseButton: {
                        style: {
                            gap: '8px',
                            // We don't want the button to have hovered state when the scaner window closes
                            ':hover': { backgroundColor: 'transparent' }
                        }
                    }
                }}
            >
                <img src={Qr} alt="" />
                <div>{t('carpay.browserScanner.scan')}</div>
            </Button>
        </>
    )
}

export { CodeScanner }
